import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

export const ReferralRedirectPage: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to register page with referral code
    if (code) {
      navigate(`/register?ref=${encodeURIComponent(code)}`, { replace: true });
    } else {
      navigate('/register', { replace: true });
    }
  }, [code, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Redirecting...
      </Typography>
    </Box>
  );
};
